import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

function fmt(v) {
    if (v == null) return "—";
    const n = v / 1_000_000;
    return `${n.toFixed(2)} M`;
}

export default function AdminDoppioniAste() {
    const [dups, setDups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState("");

    const load = useCallback(async () => {
        setLoading(true); setErr("");
        try {
            const { data } = await api.get("/auctions/admin/duplicates");
            setDups(data.duplicates || []);
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const resolve = async (tmId, keepTeamId, keepTeamName, playerName) => {
        if (!window.confirm(`Assegnare "${playerName}" a ${keepTeamName}? Le altre squadre verranno rimborsate.`)) return;
        setBusy(`${tmId}-${keepTeamId}`); setErr("");
        try {
            const { data } = await api.post("/auctions/admin/duplicates/resolve", { tm_id: tmId, keep_team_id: keepTeamId });
            const rf = (data.refunds || []).map((r) => `${r.team_name} (+${fmt(r.amount)})`).join(", ");
            alert(`Fatto. Giocatore assegnato. Rimborsi: ${rf || "nessuno"}.`);
            await load();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy("");
        }
    };

    return (
        <div data-testid="admin-auction-duplicates-page">
            <div className="op-label" style={{ color: "rgb(var(--tc-ff7a1a))" }}>// DOPPIONI ASTE</div>
            <h2 className="op-heading text-3xl mt-2 mb-2">Doppioni svincolati</h2>
            <p className="op-mono text-xs text-t8f95a3 mb-5 max-w-3xl leading-relaxed">
                Giocatori finiti su <strong className="text-tffffff">due squadre</strong> perché offerti da uno via scheda PESDB
                e da un altro solo via Transfermarkt. Scegli a quale squadra assegnare il giocatore:
                l'altra viene <strong className="text-tffffff">rimborsata</strong> automaticamente.
            </p>

            <button
                onClick={load}
                disabled={loading}
                className="op-mono text-xs uppercase tracking-wider px-4 py-2 border border-tff7a1a text-tff7a1a hover:bg-tff7a1a/10 transition-colors disabled:opacity-40 mb-4"
                data-testid="dup-refresh"
            >
                {loading ? "Carico…" : "↻ Aggiorna"}
            </button>

            {err && <div className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-xs p-2 mb-4" data-testid="dup-err">{err}</div>}

            {!loading && dups.length === 0 && (
                <div className="op-card p-6 text-center op-mono text-sm text-t8f95a3" data-testid="dup-empty">
                    ✅ Nessun doppione trovato.
                </div>
            )}

            <div className="space-y-4">
                {dups.map((d) => (
                    <div key={d.tm_id} className="op-card p-4" data-testid={`dup-card-${d.tm_id}`}>
                        <div className="flex items-baseline justify-between gap-3 mb-3">
                            <div>
                                <div className="op-heading text-lg text-tffffff">{d.name || `TM #${d.tm_id}`}</div>
                                <div className="op-mono text-[11px] text-t8f95a3">
                                    TM #{d.tm_id} · Valore {fmt(d.market_value)}
                                    {!d.has_pesdb && <span className="text-tff3b30"> · nessuna scheda PESDB</span>}
                                </div>
                            </div>
                        </div>
                        <div className="grid gap-2 sm:grid-cols-2">
                            {d.sides.map((s) => (
                                <div key={s.entry_id} className="border border-t22252a p-3 flex items-center justify-between gap-3" data-testid={`dup-side-${d.tm_id}-${s.team_id}`}>
                                    <div className="min-w-0">
                                        <div className="text-tffffff text-sm truncate">{s.team_name}</div>
                                        <div className="op-mono text-[10px] text-t8f95a3">
                                            pagato {fmt(s.amount)} ·{" "}
                                            <span style={{ color: s.is_synthetic ? "rgb(var(--tc-ff7a1a))" : "rgb(var(--tc-2bd96b))" }}>
                                                {s.is_synthetic ? "solo TM" : "scheda PESDB"}
                                            </span>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => resolve(d.tm_id, s.team_id, s.team_name, d.name)}
                                        disabled={busy === `${d.tm_id}-${s.team_id}`}
                                        className="op-mono text-[11px] uppercase tracking-wider px-3 py-1.5 border border-t2bd96b text-t2bd96b hover:bg-t2bd96b/10 transition-colors disabled:opacity-40 shrink-0"
                                        data-testid={`dup-assign-${d.tm_id}-${s.team_id}`}
                                    >
                                        {busy === `${d.tm_id}-${s.team_id}` ? "…" : "Assegna qui"}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
